var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExportProject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/export"
  }, /*#__PURE__*/React.createElement("g", {
    id: "export"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.89994 0.658447C8.0657 0.658447 8.22467 0.724295 8.34188 0.841506L10.4752 2.97484C10.7193 3.21892 10.7193 3.61464 10.4752 3.85872C10.2311 4.1028 9.8354 4.1028 9.59133 3.85872L7.89994 2.16733L6.20854 3.85872C5.96447 4.1028 5.56874 4.1028 5.32466 3.85872C5.08058 3.61464 5.08058 3.21892 5.32466 2.97484L7.45799 0.841505C7.5752 0.724295 7.73417 0.658447 7.89994 0.658447Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.89941 0.716797C8.24459 0.716797 8.52441 0.996619 8.52441 1.3418V9.8168C8.52441 10.162 8.24459 10.4418 7.89941 10.4418C7.55424 10.4418 7.27441 10.162 7.27441 9.8168V1.3418C7.27441 0.996619 7.55424 0.716797 7.89941 0.716797Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33301 7.375C1.67819 7.375 1.95801 7.65482 1.95801 8C1.95801 9.70051 2.53394 11.2072 3.55699 12.2841C4.57532 13.3562 6.07337 14.0417 7.99967 14.0417C9.92598 14.0417 11.424 13.3562 12.4424 12.2841C13.4654 11.2072 14.0413 9.70051 14.0413 8C14.0413 7.65482 14.3212 7.375 14.6663 7.375C15.0115 7.375 15.2913 7.65482 15.2913 8C15.2913 9.98282 14.6173 11.8095 13.3487 13.145C12.0753 14.4855 10.24 15.2917 7.99967 15.2917C5.75931 15.2917 3.92403 14.4855 2.6507 13.145C1.38207 11.8095 0.708008 9.98282 0.708008 8C0.708008 7.65482 0.98783 7.375 1.33301 7.375Z",
    fill: "#7C7C7C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportProject);
export default __webpack_public_path__ + "static/media/exportProject.e8c05aa6c760402d12ad85bc07a8d3ca.svg";
export { ForwardRef as ReactComponent };